import {
    HeaderComponent as SourceHeaderComponent,
    CartOverlay,
    MyAccountOverlay,
} from 'SourceComponent/Header/Header.component';
import React, { Suspense } from 'react';
import './Header.override.style';
import LogoIcon from 'Component/LogoIcon';

export {
    CartOverlay,
    MyAccountOverlay,
};
import navigationbaricon from "src/assets/navigartionbar.svg";
import searchicon from "src/assets/searchnew.svg";
import WishlistIcon from 'Component/WishlistIcon';
import history from '@scandipwa/scandipwa/src/util/History';
import NavigationMenu from 'Component/NavigationMenu';
import ClickOutside from '@scandipwa/scandipwa/src/component/ClickOutside';
import UserIcon from '@scandipwa/scandipwa/src/component/UserIcon';
import SearchField from '@scandipwa/scandipwa/src/component/SearchField';
import payment_cred from 'Src/Value/Payment_cred';
import Link from '@scandipwa/scandipwa/src/component/Link';

export class HeaderComponent extends SourceHeaderComponent {
    constructor(props) {
        super(props);

        this.state = {
            openNavigationMenu: false,
            opensearch: false
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const propsChanged = (Object.keys(nextProps)).some((key) => nextProps[key] !== this.props[key]);

        const stateChanged = (Object.keys(nextState)).some(
            (key) => nextState[key] !== this.state[key]
        );

        return propsChanged || stateChanged;
    }

    renderNavigationMenu = () => {
        const { openNavigationMenu } = this.state;
        const { device } = this.props;

        return (
            <div className={`NewHeader-NavigationMenu ${openNavigationMenu ? " NewHeader-NavigationMenu_Open" : ""}`}>
                <div className='NewHeader-NavigationMenuWrapper'>
                    <NavigationMenu
                        setnavigationmenustate={this.setnavigationmenustate}
                        device={device}
                    />
                </div>
            </div>
        )
    }

    setnavigationmenustate = () => {
        this.setState((prevState) => ({
            openNavigationMenu: !prevState.openNavigationMenu,
        }));
    }

    renderWishlistButton() {
        const { device } = this.props;

        if (device?.isMobile) {
            return null;
        }

        return (
            <div className='Header-WishlistContainer'>
                <button
                    tabIndex={0}
                    onClick={() => history.push("/wishlist")}
                    aria-label={'Wishlist'}
                    className='Header-WishlistWrapper'
                >
                    <WishlistIcon />
                </button>
            </div>
        );
    }

    renderAccountButton() {
        const {
            onMyAccountButtonClick,
            device,
        } = this.props;

        if (device.isMobile) {
            return (
                <button
                    className="Header-MyAccountWrapper"
                    tabIndex={0}
                    onClick={() => history.push("/customer/account/login")}
                    aria-label="Open my account"
                    id="myAccount"
                >
                    <UserIcon />
                </button>
            );
        }

        return (
            <button
                className="Header-MyAccountWrapper"
                tabIndex={0}
                onClick={onMyAccountButtonClick}
                aria-label="Open my account"
                id="myAccount"
            >
                <UserIcon />
            </button>
        );
    }

    renderAccountOverlay() {
        const {
            isCheckout,
            showMyAccountLogin,
            onSignIn,
            device
        } = this.props;

        if (!showMyAccountLogin || device.isMobile) {
            return null;
        }

        return (
            <Suspense fallback={this.renderAccountOverlayFallback()}>
                <MyAccountOverlay
                    onSignIn={onSignIn}
                    isCheckout={isCheckout}
                />
            </Suspense>
        );
    }

    renderAccount() {
        const {
            onMyAccountOutsideClick,
        } = this.props;

        return (
            <div key="account" className="Header-MyAccountContainer">
                <ClickOutside onClick={onMyAccountOutsideClick}>
                    <div aria-label="My account" className="Header-MyAccount">
                        {this.renderAccountButton()}
                        {this.renderAccountOverlay()}
                    </div>
                </ClickOutside>
            </div>
        );
    }

    renderMinicartOverlay() {
        const { shouldRenderCartOverlay, onMinicartOutsideClick } = this.props;

        if (!shouldRenderCartOverlay) {
            return null;
        }

        return (
            <Suspense fallback={this.renderMinicartOverlayFallback()}>
                <CartOverlay onMinicartOutsideClick={onMinicartOutsideClick} />
            </Suspense>
        );
    }

    renderMinicart(isVisible = false) {
        const {
            onMinicartOutsideClick,
        } = this.props;

        return (
            <ClickOutside onClick={onMinicartOutsideClick} key="minicart">
                <div className="Header-Button Header-Button_type_minicart">
                    {this.renderMinicartButton()}
                    {this.renderMinicartOverlay()}
                </div>
            </ClickOutside>
        );
    }

    onClearSearchButtonClick = () => {
        const { onClearSearchButtonClick } = this.props;

        onClearSearchButtonClick();

        this.setState({
            opensearch: false
        });
    }

    renderSearchField = () => {
        const {
            searchCriteria,
            onSearchOutsideClick,
            onSearchBarFocus,
            onSearchBarChange,
            hideActiveOverlay,
            isVisible,
            activeOverlay,
            device
        } = this.props;

        const { opensearch } = this.state;

        // if (device?.isMobile) {
        //     return null;
        // }

        return (
            <div className={'NewHeader-SearchWrapper' + (opensearch ? " NewHeader-SearchWrapper_Open" : "")}>
                <SearchField
                    key="search"
                    searchCriteria={searchCriteria}
                    onSearchOutsideClick={onSearchOutsideClick}
                    onSearchBarFocus={onSearchBarFocus}
                    onSearchBarChange={onSearchBarChange}
                    onClearSearchButtonClick={this.onClearSearchButtonClick}
                    isVisible={isVisible}
                    isActive={activeOverlay ? true : false}
                    hideActiveOverlay={hideActiveOverlay}
                />
            </div>
        );
    }

    rendercontenr = () => {
        const { opensearch } = this.state;

        return (
            <div className='NewHeader-Wrapper'>
                <div className='NewHeader-IconWrapper'>
                    <button className='NewHeader-IconContent' onClick={() => this.setnavigationmenustate()}>
                        <img src={navigationbaricon} />
                        <span>Menu</span>
                    </button>
                    <button className='NewHeader-IconContent' onClick={() => this.setState({ opensearch: !opensearch })}>
                        <img src={searchicon} />
                        <span>Search</span>
                    </button>
                </div>

                <div className='NewHeader-Logo'>
                    <button onClick={() => history.push("/")}>
                        <LogoIcon />
                    </button>
                </div>

                <div className='NewHeader-AccountIconWrapper'>
                    {this.renderAccount()}
                    {this.renderWishlistButton()}
                    {this.renderMinicart()}
                </div>
            </div>
        )
    }

    renderTopHeader = () => {
        return (
            <div className='NewHeader-TopHeaderWrapper'>
                <div className='NewHeader-TopHeader'>
                    {/* <p>Finance up to  $5000 ~ No Credit Required</p>
                    <span className='SpecialText'>|</span>
                    <Link
                        to={`https://solutions.snapfinance.com/merchant-links/?clientId=${payment_cred?.snap_payments?.client_id}&env=Prod`}
                        isOpenInNewTab={true}
                    >
                        <span>Get Pre-Approved Now</span>
                    </Link> */}
                    {/* <Link to={"/free-shipping"}>
                        <p>free shipping</p>
                    </Link>
                    <span className='SpecialText'>|</span>
                    <Link to={"/returns"}>
                        <p>30 days return</p>
                    </Link>
                    <span className='SpecialText'>|</span>
                    <Link to={"/lifetime-warranty"}>
                        <p>lifetime warranty</p>
                    </Link>
                    <span className='SpecialText'>|</span>
                    <Link to={"/synchrony-financing-option"}>
                        <p>financing offered</p>
                    </Link> */}
                    <p>FINANCING OPTIONS AVAILABLE</p>
                    <span className='SpecialText'> - </span>
                    <Link
                        to={`/see-all-financing-options`}
                        isOpenInNewTab={true}
                    >
                        <span>Get Pre-Approved Now</span>
                    </Link>
                </div>
            </div>
        )
    }

    render = () => {
        return (
            <>
                <div className='NewHeader'>
                    {this.renderTopHeader()}
                    {this.rendercontenr()}
                    {this.renderNavigationMenu()}
                </div>

                {this.renderSearchField()}
            </>
        )
    }
}

export default HeaderComponent;
